import { formatDate, formatDatetime, formatNumber, formatText, formatTime } from "@/comn/components/_";
import { comnUtils } from "@/comn/utils";

export const colEnvs = {
    base: `${process.env.REACT_APP_BASE}`,
};
/*
 * 프로젝트별 공통기능(함수) 사용시 작성
 */
export const colUtils = {
    /*
     * 샘플 함수
     */
    func: () => {
        console.log("call project common function");
    },

    /**
     * !==해당하는 폼에 값을 세팅한다.==!
     * Usage : colUtils.setFormValues(location.state, form.{formName})
     * @param state
     * @param form
     */
    setFormValues: (state: any, form: any) => {
        if (!comnUtils.isEmptyObject(state)) {
            Object.entries(state).map(([key, value]) => {
                console.log("key : %s , value: %s", key, value);
                form.setValue(key, value);
            });
        } else {
            console.log("has no parameter datas.");
        }
    },

    /**
     * !==Object값을 변경한다.==!
     * @param fromObj
     * @param toObj
     */
    setObjectValues: (fromObj: any, toObj: any) => {
        console.log("fromObj : " + JSON.stringify(fromObj));
        if (!comnUtils.isEmpty(fromObj)) {
            Object.keys(fromObj).forEach((item: any) => {
                console.log("setObjectValues items ::: %s", item);
                if (toObj.hasOwnProperty(item)) {
                    toObj[item] = fromObj[item];
                }
            });
        }
    },

    /////////////////////////////////////////////////////////////////////
    // Value
    /////////////////////////////////////////////////////////////////////
    /**
     * @param v Value
     * @param o Schema
     * @returns
     */
    getFormattedValue: (value: any, schema?: any) => {
        switch (schema?.type) {
            case "text":
                return formatText(value, schema);
            case "number":
                return formatNumber(value, schema);
            case "date":
                return formatDate(value);
            case "time":
                return formatTime(value);
            case "datetime":
                return formatDatetime(value);
        }
        return value;
    },

    /**
     * !==마스킹을 패턴을 반환한다.==!
     * @param pattern
     * @param separator
     * @param upper
     */
    getMaskPattern: (pattern: String, separator?: any) => {
        let mask: Array<any> = [];
        if (pattern.indexOf(",") > 0) {
            const patternArr: any[] = pattern.split(",");

            patternArr.map((strLen: any, idx: any) => {
                for (var i = 0; i < strLen; i++) {
                    mask.push(/[a-zA-Z0-9]/);
                }
                if (patternArr.length - 1 > idx) {
                    mask.push(separator);
                }
            });
        } else {
            switch (pattern) {
                case "tin":
                    mask = colUtils.getMaskPattern("3,3,3", "-");
                    break;
                case "bllNo":
                    mask = colUtils.getMaskPattern("1,4,2,7,1", "-");
                    break;
                case "secuAcctNo":
                    mask = colUtils.getMaskPattern("9,1,3", "-");
                    break;
                case "tansadNo":
                    mask = colUtils.getMaskPattern("4,2,7", "-");
                    break;
                case "hsCd":
                    mask = colUtils.getMaskPattern("4,2,2,4", ".");
                    break;
                case "rfunNo":
                    mask = colUtils.getMaskPattern("4,2,7,1", "-");
                    break;
                case "crn":
                    mask = colUtils.getMaskPattern("11,4,3", "-");
                    break;
                case "actnLotsNo":
                    mask = colUtils.getMaskPattern("4,4,3,4", "-");
                    break;
                case "wesNo":
                    mask = colUtils.getMaskPattern("9,4,2,4", "-");
                    break;
                case "appnMgmtNo":
                    mask = colUtils.getMaskPattern("4,2,7", "-");
                    break;
                case "cvtrvMgmtNo":
                    mask = colUtils.getMaskPattern("4,2,7", "-");
                    break;
                case "procsPayMgmtNo":
                    mask = colUtils.getMaskPattern("4,2,7", "-");
                    break;
                case "ioMtrxDclaNo":
                    mask = colUtils.getMaskPattern("4,7", "-");
                    break;
            }
        }
        return mask;
    },

    /**
     * !==마스킹이 적용 된 값을 return 한다.==!
     * @param str
     * @param schema
     * @param pattern
     */
    setMask: (str: any, schema?: any, pattern?: any[]) => {
        let masked: any = "";
        if (schema) {
            masked = colUtils.getFormattedValue(str, { mask: colUtils.getMaskPattern(schema), type: "text" });
        } else {
            masked = colUtils.getFormattedValue(str, { mask: pattern, type: "text" });
        }
        return masked;
    },
};
